import { ErrorHandler, Injectable } from '@angular/core';
import { MatSnackBarService } from './mat-snack-bar.service';
import { RouterService } from './router-service.service';
import { ContactService } from './contact.service';

@Injectable({
	providedIn: 'root'
})
export class ErrorService implements ErrorHandler {

	/*
	
	El propósito de este servicio es centralizar el manejo de errores genéricos
	Al día de la creación esto solo involucra:
		Redireccionar a la vista de error si era un error grande, que rompe el flujo
		Mostrar un snack si es un error chico

	*/

	constructor(private matSnackBarService:MatSnackBarService,
				private routerService:RouterService,
				private contactService:ContactService) {
	}

	handleError(error: any): void {
		if (error.name == "TimeoutError") {
			setTimeout(() => {
				this.matSnackBarService.withAction("error", "Parece que la conexión no responde", "¿Recargar página?", ()=> {
					this.routerService.reload();
				});
			}, 0);
		} else {
			this.disruptiveError(error);
		}
	}

	nonDisruptiveGenericError(callAFunction?:()=>void) {
		this.matSnackBarService.withAction("error", "Parece que ocurrió un error", "¿Contactar con soporte?", ()=> {
			this.contactService.openDialog();
		});
		if (callAFunction) {
			callAFunction();
		}
	}
	disruptiveError(error:any) {
		console.log(error);
		this.routerService.toInternalError();
	}
}